/* eslint-disable max-len */
/** @jsx jsx */
import React, {useState, useEffect} from 'react';
import Icon from 'components/atoms/Icon';
import { css, jsx } from '@emotion/core';
import FlexBox from "components/atoms/FlexBox";
import FlexBoxItem from "components/atoms/FlexBoxItem";
import BodyText from "components/atoms/BodyText";
import BoxGroupMenuLeft from "components/molecules/Menu/BoxGroupMenuLeft";
import { getMenuListByRole, menuSuperAdministrator, menuHrRole, menuLeadRole, menuSubLeadRole, menuPersonalRole } from './menuData'
import { useSelector } from 'react-redux';
import { Store } from 'modules/store';

const islapTop = window.matchMedia("(max-width: 1440px)").matches;
const isPhone = window.matchMedia("(max-width: 480px)").matches;

const style = {
  container: css({
    width: '100%', 
    maxWidth: '1750px', 
    margin: 'auto', 
    justifyContent: 'space-between', 
    marginTop: '35px'
  }),
  boxItem: css({
    padding: "8px 26px", 
    color: "#999999", 
    fontSize: "12px"
  }),
  boxSubItem: css({
    padding: "7px" 
  }),
  logo: css({
    color: "#363D3D",
    fontWeight: "bold",
    fontSize: "18px",
    marginLeft: "7px"
  }),
  logoContainer: css({
    borderBottom: "1px solid #e6e6e6",
    paddingBottom: '20px'
  })
};

const SidebarLeft: React.FC<{site: string, isAdministrator: string}> = ({site, isAdministrator}) => {
  const collapsedSidebar = useSelector((state: Store) => state.ui.appBar.collapsedSidebar);
  const recorder = useSelector((state: Store) => state.ui.recorder.recorder);
  const [menuSidebar, setMenuSidebar] = useState([]);

  function checkMenu(menu: any) {
    let arr = [];
    if(recorder?.useInsideLoginBarcodeStamp){
      arr.push({value: 'id', display: 'ID'})
    }
    if(recorder?.useInsideLoginFaceRecorderStamp){
      arr.push({value: 'face', display: '顔認証'})
    }
    if(recorder?.useGpsStamp){
      arr.push({value: 'gps', display: 'GPS'})
    }
    const index = menu.findIndex((item:any)=> item.icon === "timeRecorder");
    if(index < 0) return;
    menu[index].menuList = arr;
    return menu;
  }

  useEffect(() => {
    var arr:any = [];  
    if(site === '3' && isAdministrator === "true") {
      arr = menuSuperAdministrator;
    }
    if(site === '3' && isAdministrator === "false") {
      arr = menuHrRole;
    }
    if(site === '2' && isAdministrator === "true") {
      arr = menuLeadRole;
    }
    if(site === '2' && isAdministrator === "false") {
      arr = menuSubLeadRole;
    }
    if(site === '1'){
      arr = menuPersonalRole;
    }
      const newMenu = checkMenu(arr);
      setMenuSidebar(newMenu);
  }, [recorder]);

  return (
    <React.Fragment>
      {
        (!isPhone || (isPhone && !collapsedSidebar)) && ( 
          <FlexBoxItem 
            customStyle={css({
              flexDirection: 'column',
              alignSelf: 'flex-start',
              width: '230px',
              position: 'sticky',
              marginTop: '15px',
              top: '80px',
              whiteSpace: 'nowrap',
              maxWidth: collapsedSidebar ? '30px' : '230px',
              // transition: 'max-width 0.3s'
            })}
          >
            <FlexBox customStyle={style.logoContainer}>
              <Icon 
                type="logoHinata" 
                color={""} 
                verticalAlign="middle" 
              />
              {
                !collapsedSidebar && (
                  <BodyText customStyle={style.logo}>
                    HINATA
                  </BodyText>
                )
              }
            </FlexBox>
            <div 
              style={{
                height: islapTop ? '83vh': '85vh', 
                overflowY: 'auto' , 
                overflowX: 'hidden', 
              }}
            >
              {
                menuSidebar?.map((groupMenu: any, index: any) => {
                  return (
                    <BoxGroupMenuLeft 
                      display = {groupMenu.display} 
                      icon = {groupMenu.icon} 
                      menuList = {groupMenu.menuList} 
                    />
                  ); 
                })
              }
            </div>       
          </FlexBoxItem>
        )
      }
    </React.Fragment>
  );
};

export default SidebarLeft;
